"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CwButton = _interopRequireDefault(require("./CwButton.scss"));

var _classnames = _interopRequireDefault(require("classnames"));

var _CwImage = _interopRequireDefault(require("../cwimage/CwImage"));

var _IconPath = _interopRequireDefault(require("../../utils/IconPath"));

var CwButton =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(CwButton, _React$Component);

  function CwButton() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, CwButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(CwButton)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleKeyDown", function (e) {
      if (e.key === 'Enter') {
        if (_this.props.onClick) {
          _this.props.onClick(e);
        }
      }

      if (_this.props.onKeyDown) {
        _this.props.onKeyDown(e);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleKeyUp", function (e) {
      if (_this.props.onKeyUp) {
        _this.props.onKeyUp(e);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "focus", function () {
      _this.cwButton.focus();
    });
    return _this;
  }

  (0, _createClass2.default)(CwButton, [{
    key: "render",
    value: function render() {
      var _cx2,
          _this2 = this;

      var _this$props = this.props,
          isStandard = _this$props.isStandard,
          disabled = _this$props.disabled,
          inAGrid = _this$props.inAGrid;
      var wrapClass = (0, _classnames.default)(_CwButton.default.wrap, this.props.className, (0, _defineProperty2.default)({}, _CwButton.default.topIcon, this.props.topIcon));
      var btnClass = (0, _classnames.default)((_cx2 = {}, (0, _defineProperty2.default)(_cx2, _CwButton.default.innerStandardDisabled, isStandard && disabled && !inAGrid), (0, _defineProperty2.default)(_cx2, _CwButton.default.innerStandardActive, isStandard && !disabled && !inAGrid), (0, _defineProperty2.default)(_cx2, _CwButton.default.innerLightDisabled, !isStandard && disabled && !inAGrid), (0, _defineProperty2.default)(_cx2, _CwButton.default.innerLightActive, !isStandard && !disabled && !inAGrid), (0, _defineProperty2.default)(_cx2, _CwButton.default.innerStandardDisabledGrid, isStandard && disabled && inAGrid), (0, _defineProperty2.default)(_cx2, _CwButton.default.innerStandardActiveGrid, isStandard && !disabled && inAGrid), (0, _defineProperty2.default)(_cx2, _CwButton.default.innerLightDisabledGrid, !isStandard && disabled && inAGrid), (0, _defineProperty2.default)(_cx2, _CwButton.default.innerLightActiveGrid, !isStandard && !disabled && inAGrid), _cx2));
      var rightIconClass = (0, _classnames.default)((0, _defineProperty2.default)({}, _CwButton.default.rightIcon, _CwButton.default.rightIcon));
      return _react.default.createElement("div", {
        "data-cwid": this.props.cwId,
        onBlur: this.props.onBlur,
        style: this.props.style,
        className: wrapClass,
        tabIndex: this.props.disabled ? -1 : this.props.tabIndex,
        onClick: this.props.disabled ? null : this.props.onClick,
        onKeyPress: this.props.disabled ? null : this.handleKeyPress,
        onKeyDown: this.props.disabled ? null : this.handleKeyDown,
        onKeyUp: this.props.disabled ? null : this.handleKeyUp,
        ref: function ref(input) {
          return _this2.cwButton = input;
        },
        onFocus: this.props.onFocus,
        title: this.props.toolTip
      }, this.props.topIcon ? _react.default.createElement("div", {
        className: (0, _classnames.default)((0, _defineProperty2.default)({}, _CwButton.default.topIconClassDisabled, disabled))
      }, _react.default.createElement(_CwImage.default, {
        src: this.props.topIcon
      })) : null, _react.default.createElement("div", {
        className: btnClass
      }, this.props.icon ? _react.default.createElement(_CwImage.default, {
        src: this.props.icon
      }) : null, this.props.value, this.props.rightIcon ? _react.default.createElement(_CwImage.default, {
        className: rightIconClass,
        src: this.props.rightIcon
      }) : null, this.props.isMenu ? _react.default.createElement(_CwImage.default, {
        src: this.props.menuIcon
      }) : null));
    }
  }]);
  return CwButton;
}(_react.default.Component);

CwButton.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: _propTypes.default.string,

  /**
   * Callback function that is fired when CwButton is focused
   */
  onFocus: _propTypes.default.func,

  /**
   * Callback function that is fired when CwButton is blurred
   */
  onBlur: _propTypes.default.func,

  /**
   * The css class name to be appended to default classname
   */
  className: _propTypes.default.string,

  /**
   * Used to control button height
   */
  height: _propTypes.default.number,

  /**
   * Optional icon placed on left side of button
   */
  icon: _propTypes.default.string,

  /**
   * Used to control if the button is standard or light
   */
  isStandard: _propTypes.default.bool,

  /**
   * Used to disable a button
   */
  disabled: _propTypes.default.bool,

  /**
   * Callback function fired when button is clicked
   */
  onClick: _propTypes.default.func,

  /**
   * Override the styles of the root element
   */
  style: _propTypes.default.object,

  /**
   * Used to control order when tabbing through items
   */
  tabIndex: _propTypes.default.number,

  /**
   * Button's child
   */
  value: _propTypes.default.any,

  /**
   * Callback function when key is down while component is focused/active
   */
  onKeyDown: _propTypes.default.func,

  /**
   * Callback function when key is up after being pressed down while component is focused/active
   */
  onKeyUp: _propTypes.default.func,

  /**
   * Optional icon placed on right side of button
   */
  rightIcon: _propTypes.default.string,

  /**
   * Optional icon placed on top of button
   */
  topIcon: _propTypes.default.string,

  /**
   * Button's tooltip text
   */
  toolTip: _propTypes.default.string,

  /**
   * If true, adds dropdown icon on right
   */
  isMenu: _propTypes.default.bool,

  /**
   * Optional dropdown icon placed on right side of button
   */
  menuIcon: _propTypes.default.string
};
CwButton.defaultProps = {
  tabIndex: 0,
  menuIcon: _IconPath.default.get('Action_Expand_Light')
};
var _default = CwButton;
exports.default = _default;